import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecaptchaModule } from "ng-recaptcha";
/**
 *
 * See https://angular.io/guide/sharing-ngmodules, https://angular.io/api/core/NgModule for more info on Angular Modules.
 */
@NgModule({
  imports: [
    CommonModule,
    RecaptchaModule
  ],
  declarations: [],
  exports: [RecaptchaModule]
})

class RecaptchaModuleModule { }

export { RecaptchaModuleModule as ExportedClass };